'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import { InternalProvider } from '../../util';
import { ChipElement, TextElement } from './elements';
import { ChipIcon } from './ChipIcon';
import { StateLayer } from '../../core-components';
export const SelectionChip = /*#__PURE__*/React.forwardRef(({
  id,
  className = '',
  label,
  size = 'small',
  iconLeftSrc,
  iconRightSrc,
  hideDefaultIcon = false,
  type = 'selection',
  isSelected = false,
  edgeItemsMargin,
  ...rest
}, fRef) => {
  const renderIcon = side => {
    const isFilter = type === 'filter';
    let src;
    if (side === 'left') {
      if (!isFilter && isSelected && !hideDefaultIcon) {
        src = 'checkmark-v';
      } else if (isFilter && iconLeftSrc) {
        src = iconLeftSrc;
      }
    } else {
      if (isFilter && isSelected && !hideDefaultIcon) {
        src = 'close-x';
      } else if (!isFilter && iconRightSrc) {
        src = iconRightSrc;
      }
    }
    return src && /*#__PURE__*/React.createElement(ChipIcon, {
      src: src,
      size: size,
      side: side
    });
  };
  const leftIcon = useMemo(() => renderIcon('left'), [iconLeftSrc, type, isSelected]);
  const rightIcon = useMemo(() => renderIcon('right'), [iconRightSrc, type, isSelected]);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ChipElement, _extends({
    ref: fRef,
    id: id,
    className: `chipElement ${className}`,
    role: "checkbox",
    "aria-checked": isSelected,
    tabIndex: 0,
    $selected: isSelected,
    $size: size,
    $edgeItemsMargin: edgeItemsMargin
  }, rest), /*#__PURE__*/React.createElement(StateLayer, null), leftIcon, /*#__PURE__*/React.createElement(TextElement, {
    className: "textElement"
  }, label), rightIcon));
});